import { Alert, Empty } from 'antd'
import { WhatsappCampaign } from '../types'
import { CustomCampaignsTable } from './CustomCampaignsTable'

interface CustomCampaignsTabProps {
  campaigns: WhatsappCampaign[]
  eventSlug: string
}

export const CustomCampaignsTab = ({
  campaigns,
  eventSlug,
}: CustomCampaignsTabProps) => {
  return (
    <div>
      <Alert
        message={
          <div>
            <div className="inline-block bg-gray-800 text-white text-xs px-2 py-0.5 rounded-full mb-2">
              Note:
            </div>
          </div>
        }
        description={
          <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600">
            <li>
              Admins must create and submit custom templates via the Meta
              Business Dashboard for approval.
            </li>
            <li>
              Once approved, in the Event Owner Portal, admins can select an
              approved template and trigger a WhatsApp message blast.
            </li>
          </ul>
        }
        type="info"
        showIcon={false}
        className="mb-6"
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          padding: 0,
        }}
      />

      {/* Saved Campaigns Table */}
      <div className="mt-6">
        <div className="px-6 mb-3 flex items-center justify-between">
          <span className="text-sm font-medium text-black/85 leading-6">
            Saved Whatsapp Campaigns ({campaigns.length}):
          </span>
        </div>
        {campaigns.length === 0 ? (
          <Empty description={<div className="text-sm text-gray-600">No campaigns yet. Click "Create WhatsApp Campaign" to get started.</div>} />
        ) : (
          <CustomCampaignsTable campaigns={campaigns} eventSlug={eventSlug} />
        )}
      </div>
    </div>
  )
}
